var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.006 7.405-3.68 3.68a3.394 3.394 0 0 0-.93 1.735l-.587 2.926a1.134 1.134 0 0 1-1.913.58l-3.711-3.712-7.21 7.213a.565.565 0 1 1-.802-.801l7.213-7.214-3.712-3.711a1.132 1.132 0 0 1 .579-1.91l2.924-.585a3.392 3.392 0 0 0 1.737-.93l3.68-3.68a3.4 3.4 0 0 1 4.808 0l1.603 1.603a3.4 3.4 0 0 1 0 4.806Z",
    fill: "#fff"
  })));
};
export default SvgPin;